// Bounded geo-search timeout/cancellation. Feature-local; does not
// change global axios or auth interceptor semantics.

export const GEO_SEARCH_TIMEOUT_MS = 8000;
export const GEO_SEARCH_TIMEOUT_REASON = "geo-search-timeout";
export const GEO_SEARCH_TIMEOUT_MESSAGE =
  "Пошук триває занадто довго. Спробуйте ще раз.";

const timeoutSignals = new WeakSet();

export function createGeoSearchTimeoutController(
  externalSignal,
  timeoutMs = GEO_SEARCH_TIMEOUT_MS,
) {
  const controller = new AbortController();
  let timeoutId = null;

  const abortForTimeout = () => {
    timeoutId = null;
    if (controller.signal.aborted) return;
    timeoutSignals.add(controller.signal);
    controller.abort(GEO_SEARCH_TIMEOUT_REASON);
  };

  timeoutId = setTimeout(abortForTimeout, timeoutMs);

  const onExternalAbort = () => {
    if (timeoutId != null) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
    if (!controller.signal.aborted) {
      controller.abort(externalSignal && externalSignal.reason);
    }
  };

  if (externalSignal) {
    if (externalSignal.aborted) {
      onExternalAbort();
    } else {
      externalSignal.addEventListener("abort", onExternalAbort, { once: true });
    }
  }

  const cleanup = () => {
    if (timeoutId != null) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };

  return { signal: controller.signal, cleanup };
}

export function isGeoSearchTimeoutError(error, signal) {
  if (!error) return false;
  if (error.code === "GEO_SEARCH_TIMEOUT" || error.name === "GeoSearchTimeoutError") {
    return true;
  }
  return Boolean(signal && timeoutSignals.has(signal));
}

export function isGeoSearchAbortError(error) {
  if (!error) return false;
  return (
    error.code === "ERR_CANCELED"
    || error.name === "CanceledError"
    || error.name === "AbortError"
  );
}

export function toGeoSearchTimeoutError() {
  const err = new Error(GEO_SEARCH_TIMEOUT_MESSAGE);
  err.name = "GeoSearchTimeoutError";
  err.code = "GEO_SEARCH_TIMEOUT";
  return err;
}
